import Snap from 'snapsvg-cjs';
import createDots from './create-dots';

const sectionImages = () => {
  const bg = Snap('.js-images-bg');
  let circle = null;
  if (bg) {
    createDots(bg, 37, 33, 0, -32);
    circle = bg.circle(1330, 860, 320);
    circle.attr({
      fill: 'transparent',
      stroke: '#ff0050',
      strokeWidth: '2px',
    });
    window.addEventListener('scroll', () => {
      const offset =
        document.querySelector('.c-images').offsetTop - window.innerHeight / 2;
      circle.attr({
        cy: 1060 - (window.scrollY - offset) / 4,
      });
    });
  }
};

export default sectionImages;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/section-images.js